module.exports = __webpack_public_path__ + "img/credit-card-2-back.4ad7e135.svg";